// Re-exports the Contentful definition and React component, matching the other
// Contentful modules here (e.g. video/index.ts, spacer/index.ts).
export {LogoTransitionModalContentfulComponentDefinition} from './logoTransitionModalContentfulDefinition';
export {default} from './LogoTransitionModal';
